module.exports = __webpack_public_path__ + "img/linkedin.c7763453.svg";